import type { FormConfig, Question } from '../config/types';
import type { ManagedField } from '../service/managed-options';

export const managedQuestions = (config: FormConfig): Question[] =>
  (config.sections || [])
    .flatMap((section) =>
      section.subsections.flatMap((subsection) =>
        subsection.pages.flatMap((page) =>
          page.pageType === 'question' ? page.questions || [] : [],
        ),
      ),
    )
    .filter((question) => question.managedOptions);

export function applyManagedOptions(config: FormConfig, fields: ManagedField[]): FormConfig {
  const result: FormConfig = JSON.parse(JSON.stringify(config));
  const questions = result.sections.flatMap((section) =>
    section.subsections.flatMap((subsection) =>
      subsection.pages.flatMap((page) =>
        page.pageType === 'question' ? page.questions || [] : [],
      ),
    ),
  );
  for (const field of fields.filter((item) => item.revision > 0)) {
    const question = questions.find((item) => item.name === field.field);
    if (!question) continue;
    question.managedOptions = true;
    question.options = field.options.map((row) => ({
      option: row.value,
      retired: Boolean(row.retired),
    }));
  }
  return result;
}
